import React, { useEffect } from 'react'
import { useDocTitle } from '../components/CustomHook'
import OnlineOdemeForm from '../components/OnlineOdeme/OnlineOdeme'

const OnlineOdeme = () => {
  useDocTitle('Online Ödeme | Mobilinfo')

  useEffect(() => {
    document.body.classList.add('online-odeme-active')
    return () => {
      document.body.classList.remove('online-odeme-active')
    }
  }, [])

  return (
    <div className="online-odeme-shell">
      <OnlineOdemeForm />
    </div>
  )
}

export default OnlineOdeme
